var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"inner"},[_c('Logo'),_c('Form')],1)]),_c('div',{staticClass:"cancel",on:{"click":_vm.hide}})])])}
var staticRenderFns = []

export { render, staticRenderFns }